export const SUPPORT_CATEGORIES = [
  { slug: "money-benefits", emoji: "💰", name: "Money & Benefits", description: "Benefits, budgeting, and what to do when money gets tight" },
  { slug: "housing", emoji: "🏠", name: "Housing", description: "Renting, home admin, renewals, and where you live" },
  { slug: "legal", emoji: "⚖️", name: "Legal & Rights", description: "Separation, child arrangements, and knowing your rights" },
  { slug: "wellbeing", emoji: "🧠", name: "Wellbeing", description: "Appointments, mental load, and steadier support" },
  { slug: "education-send", emoji: "📚", name: "Education, Childcare & Additional Needs", description: "School, childcare, additional needs, and getting the right support" },
  { slug: "work", emoji: "💼", name: "Work", description: "Employment rights, self-employment, and work that fits family life" },
];

export const SUPPORT_CATEGORY_GUIDES: Record<
  string,
  {
    intro: string;
    packSlugs: string[];
  }
> = {
  "money-benefits": {
    intro:
      "Start here if money feels tight, a bill has knocked you sideways, or you are unsure what help you should be getting as a single parent.",
    packSlugs: ["benefits-check", "christmas-one-income"],
  },
  housing: {
    intro:
      "Use this area for renting problems, moving plans, and the practical admin that comes with trying to keep home life steady.",
    packSlugs: ["moving-house", "renting-goes-wrong"],
  },
  legal: {
    intro:
      "This section is for separation, co-parenting, child arrangements, understanding what your rights look like in real life, and questions like guardianship or parental responsibility for unmarried fathers.",
    packSlugs: ["separation-divorce", "co-parenting-hard", "single-dads-starting-point"],
  },
  wellbeing: {
    intro:
      "Come here when the mental load is heavy, you need steadier support, or you are trying to put a bit more backup around yourself.",
    packSlugs: ["building-support-network"],
  },
  "education-send": {
    intro:
      "For school issues, childcare questions, additional needs support, and the extra advocacy families often need when help is hard to secure.",
    packSlugs: ["getting-ehcp"],
  },
  work: {
    intro:
      "Use this area for getting back to work, switching direction, and understanding employment options that fit around family life.",
    packSlugs: ["going-back-to-work", "going-self-employed"],
  },
};

export const HELPER_PACKS = [
  { slug: "moving-house", emoji: "📦", title: "Moving House", description: "The full checklist from notice to first night" },
  { slug: "going-self-employed", emoji: "💻", title: "Going Self-Employed", description: "Everything to do in your first 90 days" },
  { slug: "separation-divorce", emoji: "⚖️", title: "Separation & Divorce", description: "The first steps when everything feels impossible" },
  { slug: "getting-ehcp", emoji: "📚", title: "Getting Support for Your Child's Additional Needs", description: "The process explained in plain English" },
  { slug: "going-back-to-work", emoji: "💼", title: "Going Back to Work", description: "Whether it's been 6 months or 6 years" },
  { slug: "christmas-one-income", emoji: "🎄", title: "Christmas on One Income", description: "Planning ahead so it doesn't hit you all at once" },
  { slug: "renting-goes-wrong", emoji: "🏠", title: "When Renting Goes Wrong", description: "What to do when your landlord is failing you" },
  { slug: "benefits-check", emoji: "💰", title: "Benefits Check", description: "Are you missing money you're entitled to?" },
  { slug: "co-parenting-hard", emoji: "🤝", title: "Co-Parenting When It's Hard", description: "Practical tools for difficult communication" },
  { slug: "building-support-network", emoji: "💗", title: "Building Your Support Network", description: "When you feel like you're doing this alone" },
  { slug: "single-dads-starting-point", emoji: "🧢", title: "Single Dads: A Starting Point", description: "Practical first steps for dads steadying rights, routines, and support" },
];
